import { render, staticRenderFns } from "./Montanti.vue?vue&type=template&id=118f6569&scoped=true"
import script from "./Montanti.vue?vue&type=script&lang=js"
export * from "./Montanti.vue?vue&type=script&lang=js"
import style0 from "./Montanti.vue?vue&type=style&index=0&id=118f6569&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f6569",
  null
  
)

export default component.exports